import { render, staticRenderFns } from "./HighPerformanceTable.vue?vue&type=template&id=5055b5e3&scoped=true"
import script from "./HighPerformanceTable.vue?vue&type=script&lang=js"
export * from "./HighPerformanceTable.vue?vue&type=script&lang=js"
import style0 from "./HighPerformanceTable.vue?vue&type=style&index=0&id=5055b5e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055b5e3",
  null
  
)

export default component.exports